import { render, staticRenderFns } from "./referbook.html?vue&type=template&id=0b459a80&scoped=true&"
import script from "./referbook.js?vue&type=script&lang=js&"
export * from "./referbook.js?vue&type=script&lang=js&"
import style0 from "./referbook.sass?vue&type=style&index=0&id=0b459a80&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b459a80",
  null
  
)

component.options.__file = "referbook.vue"
export default component.exports